import React from "react";
import { RouteComponentProps } from 'react-router';
import { EmployeeGroupDetail } from "../components/employeeGroups/EmployeeGroupDetail";

export function EmployeeGroupDetailView({ match }: RouteComponentProps<{ id: string }>) {
    return (
        <div className="view detail view-employee-group-list-view">

            <EmployeeGroupDetail id={match.params.id}></EmployeeGroupDetail>

        </div>

    );
}
